import axios from 'axios';
import { DAM_URL } from '@/hooks/damRequest';

export const axiosInstance = axios.create({
  baseURL: DAM_URL,
  headers: {
    Accept: 'application/json',
  },
  //   withCredentials: true,
});
